<div class="header">
    <h2>{{ 'packages.modal.add.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="packages-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'packages.fieldset.basic' | translate }}</h2>
        <app-form-input
            [control]="form.controls.name"
            [label]="'packages.form.name' | translate"
            [placeholder]="'packages.form.name.placeholder' | translate"
            inputId="name"
            testId="packages-add-name"
        />

        <app-form-textarea
            [control]="form.controls.description"
            [label]="'packages.form.description' | translate"
            [placeholder]="'packages.form.description.placeholder' | translate"
            inputId="description"
            testId="packages-add-description"
        />

        <div class="media-field">
            <span class="label">{{ 'packages.form.thumbnail' | translate }}</span>
            @if (form.controls.thumbnailMediaId.value; as thumbnailId) {
                <div class="media-preview">
                    <app-media-image [mediaId]="thumbnailId" [alt]="'packages.form.thumbnail' | translate" />
                </div>
            }
            <div class="media-actions">
                <p-button
                    [label]="'packages.form.selectThumbnail' | translate"
                    icon="pi pi-image"
                    [outlined]="true"
                    severity="secondary"
                    data-test="packages-add-select-thumbnail"
                    (onClick)="onSelectThumbnail()"
                />
                @if (form.controls.thumbnailMediaId.value) {
                    <p-button
                        [label]="'packages.form.removeThumbnail' | translate"
                        icon="pi pi-times"
                        [text]="true"
                        severity="secondary"
                        data-test="packages-add-remove-thumbnail"
                        (onClick)="removeThumbnail()"
                    />
                }
            </div>
        </div>
    </div>

    <div class="section">
        <h2>{{ 'packages.fieldset.content' | translate }}</h2>
        <app-form-multiselect
            [control]="form.controls.courseIds"
            [label]="'packages.form.courses' | translate"
            [placeholder]="'packages.form.courses.placeholder' | translate"
            [options]="courseOptions()"
            [filter]="true"
            inputId="courseIds"
            testId="packages-add-course-ids"
        />

        <app-form-multiselect
            [control]="form.controls.pathwayIds"
            [label]="'packages.form.pathways' | translate"
            [placeholder]="'packages.form.pathways.placeholder' | translate"
            [options]="pathwayOptions()"
            [filter]="true"
            inputId="pathwayIds"
            testId="packages-add-pathway-ids"
        />
    </div>

    <div class="section">
        <h2>{{ 'packages.fieldset.availability' | translate }}</h2>
        <app-form-radio-button
            [control]="form.controls.availabilityType"
            [label]="'packages.form.availability' | translate"
            [options]="availabilityOptions"
            inputId="availabilityType"
            name="availabilityType"
            testId="packages-add-availability-type"
        />

        @if (isRestricted()) {
            <app-form-multiselect
                [control]="form.controls.assignedSchoolIds"
                [label]="'packages.form.schools' | translate"
                [placeholder]="'packages.form.schools.placeholder' | translate"
                [options]="schoolOptions()"
                [filter]="true"
                inputId="assignedSchoolIds"
                testId="packages-add-assigned-school-ids"
            />
        }
    </div>

    <div class="section">
        <h2>{{ 'packages.fieldset.pricing' | translate }}</h2>
        <app-pricing-configurator [pricingList]="pricingList()" [customPricingList]="form.controls.customPricingList" [pricingEntities]="pricingEntities()" />

        <div class="purchasable">
            <app-form-checkbox
                [control]="form.controls.isPurchasable"
                [label]="'packages.purchasable.label' | translate"
                inputId="isPurchasable"
                testId="packages-add-is-purchasable"
            />
            @if (form.controls.isPurchasable.disabled) {
                <p class="hint">{{ 'packages.purchasable.disabledHint' | translate }}</p>
            }
        </div>
    </div>
</form>

<div class="footer">
    <p-button [label]="'packages.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="packages-add-cancel" (onClick)="close()" />
    <p-button
        type="submit"
        [label]="'packages.form.create' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="packages-add-submit"
        (onClick)="onSubmit()"
    />
</div>
